export function makeDebouncedCallback<T extends any[]>(
  cb: (...args: T) => unknown,
  ms: number = 50,
) {
  let timeout = -1;

  return (...args: T) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cb(...args);
    }, ms) as unknown as number;
  };
}
